import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-2 font-body font-semibold text-[15px] px-7 py-3.5 rounded-[2px] transition-[background-color,color,transform,box-shadow] duration-200 focus-ring disabled:opacity-60 disabled:cursor-not-allowed";

const variants = {
  primary: "bg-ink text-white hover:bg-inkhover",
  accent: "bg-amber text-maintext hover:bg-amber-hover",
  outline: "border border-white/30 text-white hover:border-amber hover:text-amber bg-transparent",
  outlineDark: "border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-white bg-transparent",
  ghost: "text-ink hover:text-amber-hover bg-transparent",
};

export function Button({ as = "button", to, href, variant = "primary", arrow = false, className = "", children, ...props }) {
  const cls = `${base} ${variants[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {arrow && <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />}
    </>
  );
  if (to) return <Link to={to} className={cls} {...props}>{inner}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{inner}</a>;
  const Tag = as;
  return <Tag className={cls} {...props}>{inner}</Tag>;
}
